import DomainTargeting from './domain-targeting';

export default DomainTargeting;
